export const PIXEL_ID = '3070568583125644'

export const initPixel = () => {
  if (typeof window !== 'undefined') {
    // Basic pixel code would go here in a real implementation
    // For this React implementation, we'll assume the script is loaded in index.html
    // or we can inject it dynamically if needed, but usually we just track events
    console.log('Pixel Initialized:', PIXEL_ID)
  }
}

export const trackEvent = (eventName: string, data?: any) => {
  if (typeof window !== 'undefined' && (window as any).fbq) {
    ;(window as any).fbq('track', eventName, data)
  } else {
    console.log('Pixel Event:', eventName, data)
  }
}
